import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import isDiDecryptable from '@/utils/is-di-decryptable';
import useField from '../../../../vault/hooks/use-field';
import AddressType from '../components/address-card/types';
const attributesByType: Record<AddressType, DataIdentifier[]> = {
  [AddressType.business]: ['business.address_line1', 'business.address_line2', 'business.city', 'business.state', 'business.zip', 'business.country'],
  [AddressType.residential]: ['id.address_line1', 'id.address_line2', 'id.city', 'id.state', 'id.zip', 'id.country']
};
const useAddressFieldsProps = entity => {
  const $ = _c(8);
  const getProps = useField(entity);
  let t0;
  if ($[0] !== entity) {
    t0 = type => {
      const dis = attributesByType[type].filter(di => isDiDecryptable(entity, di));
      const disSet = new Set(dis);
      const filteredAttributes = entity.data.filter(attr => disSet.has(attr.identifier as DataIdentifier)).map(_temp) as DataIdentifier[];
      const sortedAttributes = filteredAttributes.sort((a, b) => dis.indexOf(a) - dis.indexOf(b));
      if (sortedAttributes.includes("id.address_line1") && !sortedAttributes.includes("id.address_line2")) {
        const index = sortedAttributes.indexOf("id.address_line1");
        sortedAttributes.splice(index + 1, 0, "id.address_line2");
      }
      return sortedAttributes;
    };
    $[0] = entity;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getAddressDis = t0;
  let t1;
  if ($[2] !== getAddressDis || $[3] !== getProps) {
    t1 = type_0 => {
      const dis_0 = getAddressDis(type_0);
      return dis_0.map(getProps);
    };
    $[2] = getAddressDis;
    $[3] = getProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getAddressFieldsProps = t1;
  let t2;
  if ($[5] !== getAddressDis || $[6] !== getAddressFieldsProps) {
    t2 = {
      getAddressDis,
      getAddressFieldsProps
    };
    $[5] = getAddressDis;
    $[6] = getAddressFieldsProps;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default useAddressFieldsProps;
function _temp(attr_0) {
  return attr_0.identifier;
}